"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPSOLVE_INFO = void 0;
exports.UPSOLVE_INFO = {
  name: "Upsolve",
  address: {
    street1: "228 Park Ave S PMB 53933",
    city: "New York",
    state: "NY",
    zipcode: "10003-1502",
    country: "US"
  },
  phoneNumber: "347-850-2656",
  managingAttorney: "Tina Tran",
  executiveDirector: "Jonathan Petts"
};